import { AppBar, Box, Toolbar } from "@mui/material";
import { styles } from "./styleHeader";
import { ReactNode } from "react";

interface HeaderProps {
  children?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  return (
    <AppBar position="static" elevation={0} sx={styles.root}>
      <Toolbar disableGutters sx={styles.toolbar}>
        <Box sx={styles.wrapper}>{children}</Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
